(function () {
  if (window.__productCompositionPrimaryInit) return;
  window.__productCompositionPrimaryInit = true;

  function loadComposition(container) {
    if (!container || container.dataset.loaded === 'true') return;

    var url = container.dataset.url;
    var sectionId = container.dataset.sectionId;
    var locale = container.dataset.locale;

    if (!url || !sectionId) {
      container.removeAttribute('aria-busy');
      return;
    }

    var separator = url.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = url + separator + 'sections=' + encodeURIComponent(sectionId);

    if (locale) {
      fetchUrl += '&locale=' + encodeURIComponent(locale);
    }

    fetch(fetchUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-composition-content]');

        if (content) {
          container.innerHTML = content.innerHTML;
        }
      })
      .catch(function () {
        /* Keep empty on failure rather than showing a truncated translation */
      })
      .finally(function () {
        container.dataset.loaded = 'true';
        container.removeAttribute('aria-busy');
      });
  }

  function init() {
    document.querySelectorAll('[data-product-composition-primary]').forEach(loadComposition);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
